export default {
  orgCount: 'Participating businesses',
  businessCount: 'Total business volume',
  applyCount: 'Total number of modules',
  interfaceCount: 'Total number of interfaces',
  evidenceCount: 'Blockchain documentation',
  verifyCount: 'Blockchain verification',
  shareTotal: 'Total number of shares',
  realTimeLog: 'Real-time log',
  top10: 'Enterprise Use Top10',
  orgName: 'Business name',
  digifaxTitle: 'digital mode (send | receive)',
  apiCall: 'Interface call',
  orgUseTitle: 'New transfer volume in recent January',
  api: 'API',
  digifax: 'digital module',
  blockchainStatistics: 'Blockchain statistics',
  linkFile: 'Link file',
  uplinkData: 'up-link data',
  behavioralCertificate: 'BehavioralCertificate'
};



// WEBPACK FOOTER //
// ./src/views/screen/screen.en.js